export default "/_next/static/images/img1-79493496def27e5d3be834bf861c56fe.png";